import axios from "../../config/axiosConfig";
import { CREATE_WHATSAPP_CUSTOMER, GET_WHATSAPP_CUSTOMER, WHATSAPP_CUSTOMER_REQUEST, DELETE_WHATSAPP_CUSTOMER, UPDATE_WHATSAPP_CUSTOMER, WHATSAPP_CUSTOMER_REQUEST_FAILURE, WHATSAPP_CUSTOMER_REQUEST_SUCCESS, GET_WHATSAPP_CUSTOMER_DETAIL } from "../types";

export const getWhatsappCustomers = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WHATSAPP_CUSTOMER_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/whatsapp-customer/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_WHATSAPP_CUSTOMER, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

// export const getWhatsappPlanById = (id) => {
//   return async (dispatch, getState) => {
//     try {
//       dispatch({ type: WHATSAPP_CUSTOMER_REQUEST });
//       const { auth } = getState();
//       let params = { customerId: auth?.user?.Customer_Id };
//       if (!auth?.company?.Common_Master) {
//         params = { ...params, companyId: auth.company?.id }
//       }
//       return axios.get(`/whatsapp-customer/getById`, { params }).then((response) => {
//         if (response.data) {
//           dispatch({ type: GET_WHATSAPP_CUSTOMER, payload: response.data });
//         }
//         return response;
//       }).catch((error) => {
//         console.error(error);
//         dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_FAILURE, error: error.message });
//       });
//     } catch (error) {
//       console.error(error);
//       dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_FAILURE, error: error.message });
//       throw error;
//     }
//   }
// }

export const createWhatsappCustomer = (whatsappCustomer) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: WHATSAPP_CUSTOMER_REQUEST });
      return axios.post("/whatsapp-customer/create", whatsappCustomer,
        { params: { userId: auth.user?.id }}
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_WHATSAPP_CUSTOMER, payload: response.data });
        } else {
          dispatch({
            type: WHATSAPP_CUSTOMER_REQUEST_FAILURE,
            error: "WhatsappCustomer create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createWhatsappRecharge = (whatsappCustomerRecharge) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: WHATSAPP_CUSTOMER_REQUEST });
      return axios.post("/whatsapp-customer/add-recharge", whatsappCustomerRecharge,
        { params: { userId: auth.user?.id }}
      ).then((response) => {
        if (response.data) {
          dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_SUCCESS, payload: response.data });
        } else {
          dispatch({
            type: WHATSAPP_CUSTOMER_REQUEST_FAILURE,
            error: "WhatsappCustomer add-recharge failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getCustomerDetails = (customerId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: WHATSAPP_CUSTOMER_REQUEST });
      return axios.get("/whatsapp-customer/customer-detail",
        { params: { Customer_Id: customerId }}
      ).then((response) => {
        if (response?.data) {
            console.log('response?.data?.data>>>', response?.data?.data);
            
          dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_SUCCESS, payload: response?.data?.data });
        } else {
          dispatch({
            type: WHATSAPP_CUSTOMER_REQUEST_FAILURE,
            error: "WhatsappCustomer customerDetail failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WHATSAPP_CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

